import React, { useState } from "react";
import MetaTags from "react-meta-tags";
import {
  Card,
  CardBody,
  Col,
  Container,
  Label,
  Row,
  Form,
  Button,
  CardTitle,
  Input,
  FormFeedback,
  UncontrolledTooltip,
} from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";

// Redux
import { connect, useDispatch } from "react-redux";
import { withRouter, useHistory, Link } from "react-router-dom";

// actions
import { vehicleCreate } from "store/actions";

//Import Breadcrumb
import Breadcrumb from "components/Common/Breadcrumb";
import Loader from "components/Common/Loader";

const VehicleCreate = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const redirect = () => {
    history.push("/vehicles");
  };

  const [formData, setFormData] = useState({
    plate: "",
    driver: "",
  });

  const { plate, driver } = formData;

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value.toUpperCase() });
  };

  const onSubmit = (e) => {
    e.preventDefault();
    dispatch(vehicleCreate(formData));
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Carnesvilla | Vehículos </title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title={"Carnesvilla"} breadcrumbItem={"Vehículos"} />
          {props.loading ? (
            <Loader />
          ) : (
            <div className="d-flex justify-content-center">
              {props.vehicleCreated.id ? (
                <SweetAlert
                  title="¡Hecho!"
                  success
                  showConfirm={true}
                  onConfirm={() => {
                    redirect();
                  }}
                >
                  El vehículo <b>{props.vehicleCreated.plate}</b> se ha
                  agregado correctamente.
                </SweetAlert>
              ) : null}
              <Card
                style={{
                  width: "70rem",
                }}
              >
                <CardTitle className="ps-3 pt-3">
                  <h2 className="mb-3 font-size-20">Nuevo vehículo</h2>
                </CardTitle>
                <CardBody>
                  <Form onSubmit={onSubmit}>
                    <Row className="justify-content-md-center">
                      <Col lg={5}>
                        <p>Información del vehículo</p>
                      </Col>
                    </Row>
                    <Row className="justify-content-md-center">
                      <Col lg={5}>
                        <div className="input-group mb-3">
                          <span className="input-group-text">
                            <i className="bx bx-car bx-sm" />
                          </span>
                          <div className="form-floating">
                            <Input
                              type="text"
                              style={{ textTransform: "uppercase" }}
                              className="form-control"
                              placeholder="Placa"
                              name="plate"
                              id="plate"
                              value={plate}
                              onChange={onChange}
                              {...(props.error && {
                                ...(props.error.plate
                                  ? { invalid: true }
                                  : { valid: true }),
                              })}
                              required
                            />
                            <FormFeedback tooltip>
                              {props.error.plate}
                            </FormFeedback>
                            <Label for="plate">Placa</Label>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <Row className="justify-content-md-center">
                      <Col lg={5}>
                        <div className="input-group mb-3">
                          <span className="input-group-text">
                            <i className="bx bx-id-card bx-sm" />
                          </span>
                          <div className="form-floating">
                            <Input
                              type="text"
                              style={{ textTransform: "uppercase" }}
                              className="form-control"
                              placeholder="Nombre del conductor"
                              name="driver"
                              id="driver"
                              value={driver}
                              onChange={onChange}
                              {...(props.error && {
                                ...(props.error.driver
                                  ? { invalid: true }
                                  : { valid: true }),
                              })}
                              required
                            />
                            <FormFeedback tooltip>
                              {props.error.driver}
                            </FormFeedback>
                            <Label for="driver">Nombre del conductor</Label>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <Row className="justify-content-md-center mt-4 ms-5">
                      <Col lg={3}>
                        <Link className="btn btn-danger me-4" to="/vehicles">
                          Cancelar
                        </Link>

                        <Button color="success" type="submit">
                          Crear
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </div>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const { error, loading, vehicleCreated } = state.Vehicle;
  return { error, loading, vehicleCreated };
};

export default withRouter(connect(mapStateToProps)(VehicleCreate));
